import React from "react";

import PatientSaleHistorySaleLine from "./PatientSaleHistorySaleLine";

import ButtonIconH from "../../components/ButtonIconH";

import { formatCurrency } from "../utils/utils";

import moment from "moment";

export default ({
  id,
  date,
  opticName,
  soldBy,
  campaign,
  type,
  total,
  paid,
  pending,
  lines,
  onClickMenuOption,
}) => {
  const onClickShow = () => {
    onClickMenuOption("venta", { saleId: id });
  };

  return (
    <div className="history-box">
      <div className="history-box-header">
        <div className="history-box-header-fields">
          <div className="history-box-header-fields-part1">
            <div className="history-box-header-field">
              <span className="history-box-tag">Fecha</span>
              <span>{moment(date).format("DD/MM/YYYY")}</span>
            </div>
            <div className="history-box-header-field">
              <span className="history-box-tag">Óptica</span>
              <span>{opticName}</span>
            </div>
            <div className="history-box-header-field">
              <span className="history-box-tag">Realizada por</span>
              <span>{soldBy}</span>
            </div>
            <div className="history-box-header-field">
              <span className="history-box-tag">Motivo</span>
              <span>{campaign === "" ? "-" : campaign}</span>
            </div>
            <div className="history-box-header-field">
              <span className="history-box-tag">Tipo</span>
              <span>{type}</span>
            </div>
          </div>
          <div className="history-box-header-fields-part2">
            <div className="history-box-header-field">
              <span className="history-box-tag">Total</span>
              <span>{formatCurrency(total)}</span>
            </div>
            <div className="history-box-header-field">
              <span className="history-box-tag">Abono</span>
              <span>{formatCurrency(paid)}</span>
            </div>
            <div className="history-box-header-field">
              <span className="history-box-tag">Pendiente</span>
              <span>{formatCurrency(pending)}</span>
            </div>
          </div>
        </div>
        <div style={{ padding: "5px" }}>
          <ButtonIconH text="Mostrar" small onClick={onClickShow} />
        </div>
      </div>
      <div className="history-box-content">
        <div className="section-patient-sale-history-table-header">
          <div>
            <span>Código</span>
          </div>
          <div>
            <span>Descripción del producto</span>
          </div>
          <div className="section-patient-sale-history-align-end">
            <span>PVP</span>
          </div>
          <div className="section-patient-sale-history-align-center">
            <span>Dto</span>
          </div>
          <div className="section-patient-sale-history-align-center">
            <span>IVA</span>
          </div>
          <div className="section-patient-sale-history-align-end">
            <span>PVU</span>
          </div>
          <div className="section-patient-sale-history-align-center">
            <span>Uds</span>
          </div>
          <div className="section-patient-sale-history-align-end">
            <span>Total</span>
          </div>
        </div>
        {lines.map((line, index) => (
          <PatientSaleHistorySaleLine
            key={index}
            code={line.code}
            description={line.description}
            pvp={line.pvp}
            dto={line.porcDto}
            iva={line.porcIVA}
            pvu={line.pvu}
            uds={line.uds}
            total={line.total}
          />
        ))}
      </div>
    </div>
  );
};
